export default "__VITE_ASSET__mQXN$Ycj__"